/* ================================
   PRODUCT ITEM – GLOBAL FUNCTIONS
   ================================ */

$(document).ready(function () {

  /* ===================================================
     1) Cargar los precios cuando aparece un Product Item
     =================================================== */
  $('.cta-product-item').each(function () {
    const $item = $(this);
    const $select = $item.find('.cta-product-item__variants select');
    const $selectedOption = $select.find('option:selected');

    loadPriceITEM($item);
    changeImageITEM($select, $selectedOption);
  });


  /* ===================================================
     2) Cambiar precio e imagen al cambiar variante
     =================================================== */
  $(document).on('change', '.cta-product-item__variants select', function () {
    const $item = $(this).closest('.cta-product-item');
    const $selectedOption = $(this).find('option:selected');

    loadPriceITEM($item);
    changeImageITEM($(this), $selectedOption);
  });


  /* ===================================================
     3) Restaurar labels reales de cada option
     =================================================== */
  reloadLabelsITEM();


  /* ===================================================
     4) Validación del campo CUSTOM NAME
     =================================================== */
  $('.cta-product-item .custom-complete-set input').on('input', function () {
    validarCustomItem($(this));
  });

  // Ejecutar validación al cargar
  $('.cta-product-item .custom-complete-set input').each(function () {
    validarCustomItem($(this));
  });

});


/* ===================================================
   FUNCIÓN: Actualizar precios en PRODUCT ITEM
   =================================================== */
function loadPriceITEM($item) {
  let variant = $item.find('.cta-product-item__variants select option:selected');
  let price = variant.attr('data-price');
  let compare = variant.attr('data-compare-price');
  let campaign = variant.attr('data-discount');

  // Precio normal
  $item.find('.cta-product-item__info-price .price').text(price);

  // Precio campaña
  if (campaign) {
    $item.find('.cta-product-item__info-price .price-campaign-complete').text(campaign);
    if(compare){
      $item.find('.cta-product-item__info-price .label-campaign-complete').text('SALE SAVING + 20% OFF');
    } else {
      $item.find('.cta-product-item__info-price .label-campaign-complete').text('20% OFF');
    }
  } else {
    $item.find('.cta-product-item__info-price .price-campaign-complete').text('');
    $item.find('.cta-product-item__info-price .price-campaign-complete').hide();
  }

  // Compare at price
  if (compare) {
    $item.find('.cta-product-item__info-price .compate-at-price').text(compare);
    $item.find('.cta-product-item__info-price .compate-at-price').show();
  } else {
    $item.find('.cta-product-item__info-price .compate-at-price').text('');
    $item.find('.cta-product-item__info-price .compate-at-price').hide();
  }
}


/* ===================================================
   FUNCIÓN: Restaurar label original en los selects
   =================================================== */
function reloadLabelsITEM() {
  $('.cta-product-item__variants select option').each(function () {
    let label = $(this).data('label');
    if (label) {
      $(this).text(label);
    }
  });
}


/* ===================================================
   FUNCIÓN: Cambiar imagen al seleccionar variante
   =================================================== */
function changeImageITEM($select, $selectedOption) {
  const imageUrl = $selectedOption.data('imagen');
  if (imageUrl) {
    const $image = $select.closest('.cta-product-item').find('img:first');

    if ($image.length) {
      $image.attr('src', imageUrl);
    }
  }
}



/* ===================================================
   FUNCIÓN: Validar texto CUSTOM NAME en Product Item
   =================================================== */
function validarCustomItem($input) {
  const value = $input.val().trim();
  const $wrapper = $input.closest('.custom-complete-set');
  const $error = $wrapper.siblings('.name-error-custom-set');
  const $button = $wrapper.closest('.cta-product-item').find('.cta-product-item__addToCart');

  if (value === '') {
    $error.hide();
  } else {
    $error.hide();
  }
}



/* ===================================================
   FUNCIÓN: AGREGAR AL CARRITO (PRODUCT ITEM)
   =================================================== */
function addToCartProductItem() {

  const $button = $(event.target);
  const $item = $button.closest('.cta-product-item');

  const $qtyInput = $item.find('.number-input-field');
  const quantity = parseInt($qtyInput.val());

  const $select = $item.find('.cta-product-item__variants select');
  const variantId = $select.val();

  const $customWrapper = $item.find('.custom-complete-set');
  const $customInput = $customWrapper.find('input');
  const $error = $item.find('.name-error-custom-set');

  if (!quantity || quantity < 1) return;

  // Validación de CUSTOM NAME
  if ($customWrapper.length) {
    const customValue = $customInput.val().trim();

    if (customValue === '') {
      $error.show();
      return;
    } else {
      $error.hide();
    }
  }

  // Estado visual del botón
  $button.text('ADDING...');
  $button.prop('disabled', true);

  const data = {
    id: variantId,
    quantity: quantity
  };

  // Si el producto tiene campo personalizado
  if ($customWrapper.length) {
    const customValue = $customInput.val().trim();
    if (customValue !== '') {
      data.properties = { 'Name': customValue };
    }
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      $button.text('ADDED!');
      setTimeout(() => {
        $button.text('ADD TO CART');
        $button.prop('disabled', false);
      }, 1000);
    },
    error: function () {
      $button.text('ERROR');
      setTimeout(() => {
        $button.text('ADD TO CART');
        $button.prop('disabled', false);
      }, 1000);
    }
  });
}
